import React from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useI18n } from '../../contexts/I18nContext';

interface DeckVisibilityToggleProps {
  isPublic: boolean;
  onChange: (isPublic: boolean) => void;
  disabled?: boolean;
}

export function DeckVisibilityToggle({ isPublic, onChange, disabled }: DeckVisibilityToggleProps) {
  const { t } = useI18n();
  
  return (
    <button
      onClick={() => onChange(!isPublic)}
      disabled={disabled}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md border transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      title={isPublic ? t('deck_visibility.public_title') : t('deck_visibility.private_title')}
    >
      {isPublic ? (
        <>
          <Eye className="w-4 h-4" />
          {t('deck_visibility.public')}
        </>
      ) : (
        <>
          <EyeOff className="w-4 h-4" />
          {t('deck_visibility.private')}
        </>
      )}
    </button>
  );
}